import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle, Tooltip} from "@atttomyx/react-components";
import {datetime, numbers} from "@atttomyx/shared-utils";
import {MESSAGE_AI, TEMPLATE_ID_BUSINESS_PLAN, TEMPLATE_ID_PITCH_DECK} from "../../constants";
import "./fileCard.css";

const FileCard = (props) => {
    const { document, filters, children } = props;

    return <Card className="file-card" raised={true}>
        <CardContent>
            <CardTitle>
                {document.fileName}
                {document.templateId === TEMPLATE_ID_BUSINESS_PLAN || document.templateId === TEMPLATE_ID_PITCH_DECK ?
                    <span className="tooltip"><Tooltip message={MESSAGE_AI}/></span> : null}
            </CardTitle>
            <CardData
                filters={filters}
                data={document}
                keyToMetadata={{
                    contentType: {
                        title: "Type",
                    },
                    size: {
                        title: "Size",
                        formatter: numbers.abbreviateNumber,
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default FileCard;
